


























































import Vue from 'vue'
import UiButton from '../UiButton'
import UiIcon from '../UiIcon'
import UiInput from '../UiInput'
export default (Vue as typeof UiInput).extend({
  name: 'UiInputFile',
  components: {
    UiInput,
    UiButton,
    UiIcon
  },
  extends: UiInput,
  props: {
    button: {
      type: String,
      default: 'Upload Attachement'
    }
  },
  data () {
    return {
      file: undefined
    }
  },
  methods: {
    reset (): void {
      (this.$refs as any).input.value = ''
      this.file = undefined
      this.$emit('change', { target: this.$refs.input })
    },
    onClick (): void {
      (this.$refs as any).input?.click()
    },
    onInput (event: any): void {
      if (event.target.files) {
        this.file = event.target.files[0]
      }
      this.$emit('change', event)
    }
  }
})
